import { HeadlessCore } from "@dotdev/headless-core-app";

export const useCore = () => {
  return {
    helpers: {
      ...HeadlessCore.helpers,
    },
  };
};
